<template>
    <div class="invoice-filter-bar">
        <!-- Status Tabs (Pills) -->
        <div class="ppv2-mb-6 ppv2-flex ppv2-flex-wrap ppv2-items-center ppv2-gap-3">
            <button
                v-for="filter in typeFilters"
                :key="filter.id"
                :class="[
                    'ppv2-rounded-full md:ppv2-px-4 ppv2-px-2 ppv2-py-1.5 ppv2-text-sm poppinsMedium ppv2-transition-colors',
                    activeFilter === filter.id
                        ? 'ppv2-bg-[#191D41] ppv2-text-white ppv2-shadow-lg'
                        : 'ppv2-bg-white ppv2-text-[#021832] ppv2-border ppv2-border-gray-200 hover:ppv2-bg-gray-50',
                ]"
                @click="$emit('update:activeFilter', filter.id)"
            >
                {{ filter.label }}
                <span
                    v-if="filter.count !== undefined"
                    :class="[
                        'ppv2-flex ppv2-items-center ppv2-justify-center ppv2-min-w-[24px] ppv2-h-[24px] ppv2-rounded-full ppv2-text-xs ppv2-px-1.5 ppv2-ml-1',
                        activeFilter === filter.id ? getBadgeColor(filter.id) : 'ppv2-bg-gray-100 ppv2-text-gray-600',
                    ]"
                >
                    {{ filter.count }}
                </span>
            </button>
        </div>

        <!-- Filters Row -->
        <div class="ppv2-flex ppv2-flex-wrap ppv2-items-center ppv2-mb-6" :style="{ gap: normalizeSize(16, true) }">
            <!-- Search -->
            <div class="ppv2-relative">
                <div class="ppv2-absolute ppv2-left-4 ppv2-top-1/2 ppv2-transform ppv2--translate-y-1/2 ppv2-text-gray-400">
                    <SearchIcon :size="18" />
                </div>
                <input
                    :value="searchQuery"
                    @input="$emit('update:searchQuery', $event.target.value)"
                    type="text"
                    class="ppv2-w-[50px] focus:ppv2-w-[300px] ppv2-transition-all ppv2-duration-300 ppv2-pl-10 ppv2-pr-4 ppv2-py-2.5 ppv2-border ppv2-border-[#191D41] ppv2-rounded-xl focus:ppv2-ring-2 focus:ppv2-ring-purple-500 ppv2-outline-none ppv2-text-sm"
                    placeholder=" "
                />
            </div>

            <!-- Date Range -->
            <invoice-date-filter
                :start-date="dateRange.start"
                :end-date="dateRange.end"
                @update:startDate="$emit('update:dateRange', { ...dateRange, start: $event })"
                @update:endDate="$emit('update:dateRange', { ...dateRange, end: $event })"
            />

            <!-- Type -->
            <button class="filter-btn">
                <FileText :size="18" />
                <span>{{ $t('invoices.filter_type') }}</span>
                <ChevronDown :size="16" class="ppv2-text-gray-400" />
            </button>

            <!-- Échéance -->
            <button class="filter-btn">
                <CalendarClock :size="18" />
                <span>{{ $t('invoices.filter_due_date') }}</span>
                <ChevronDown :size="16" class="ppv2-text-gray-400" />
            </button>

            <!-- Filtres -->
            <button class="filter-btn">
                <LayoutGrid :size="18" />
                <span>{{ $t('invoices.filter_advanced') }}</span>
                <ChevronDown :size="16" class="ppv2-text-gray-400" />
            </button>

            <div class="ppv2-flex-grow"></div>

            <!-- Modifier les colonnes -->
            <button class="filter-btn">
                <FileEdit :size="18" />
                <span>{{ $t('invoices.edit_columns') }}</span>
                <ChevronDown :size="16" class="ppv2-text-gray-400" />
            </button>
        </div>
    </div>
</template>

<script>
import normalizeSize from '../../../utils/normalizeSize'

import { Search as SearchIcon, FileText, CalendarClock, LayoutGrid, FileEdit, ChevronDown } from 'lucide-vue'
import InvoiceDateFilter from '../InvoiceDateFilter.vue'

export default {
    name: 'InvoiceFilterBar',
    components: {
        SearchIcon,
        FileText,
        CalendarClock,
        LayoutGrid,
        FileEdit,
        ChevronDown,
        InvoiceDateFilter,
    },
    props: {
        activeFilter: {
            type: String,
            default: 'all',
        },
        searchQuery: {
            type: String,
            default: '',
        },
        typeFilters: {
            type: Array,
            default: () => [],
        },
        dateRange: {
            type: Object,
            default: () => ({ start: null, end: null }),
        },
    },
    methods: {
        normalizeSize,
        getBadgeColor(filterId) {
            switch (filterId) {
                case 'upcoming':
                    return 'ppv2-bg-[#0075FF] ppv2-text-white'
                case 'overdue':
                    return 'ppv2-bg-[#DBA800] ppv2-text-white'
                case 'paid':
                    return 'ppv2-bg-[#035B2F] ppv2-text-white'
                case 'draft':
                    return 'ppv2-bg-[#9C9C9C] ppv2-text-white'
                default:
                    return 'ppv2-bg-[#5932EA] ppv2-text-white'
            }
        },
    },
}
</script>

<style scoped>
.filter-btn {
    @apply ppv2-flex ppv2-items-center ppv2-gap-2 ppv2-border ppv2-border-[#191D41] ppv2-rounded-xl ppv2-px-4 ppv2-py-2.5 ppv2-text-[#191D41] ppv2-bg-white hover:ppv2-bg-gray-50 ppv2-transition-colors ppv2-text-sm;
    font-family: 'Poppins Light', sans-serif;
}
</style>
